import Toast from "components/cms/Toast";
import NewsletterPageStack, {
  NEWSLETTER_ARCHIVE_KEYS,
  NEWSLETTER_HERO_KEYS,
  NEWSLETTER_INSIDE_KEYS,
} from "components/cms/NewsletterPageStack";
import useCmsPage from "hooks/useCmsPage";
import { addNewsletterPage, getNewsletterPage, updateNewsletterPage } from "api/newsletterpage";
import { emptyNewsletterPage } from "utils/defaults";

export default function NewsletterPageCms() {
  const cms = useCmsPage({
    load: getNewsletterPage,
    create: addNewsletterPage,
    update: updateNewsletterPage,
    empty: emptyNewsletterPage,
    mapResponse: (res) => res.data?.data,
  });
  const {
    form,
    setField,
    frMap,
    exists,
    loading,
    toast,
    setToast,
    save,
    saveSection,
    savingSection,
    isSectionDirty,
  } = cms;

  const onSave = (section, keys) => {
    if (!exists) {
      save();
      return;
    }
    saveSection(section, keys);
  };

  if (loading) {
    return <p className="mt-5 text-gray-600">Loading Newsletter page…</p>;
  }

  return (
    <div className="mt-3">
      <Toast toast={toast} onClose={() => setToast(null)} />
      {!exists ? (
        <p className="mb-3 text-sm text-gray-500">
          Newsletter page is not saved yet. Click Save to create it. Until then the
          site keeps the current copy.
        </p>
      ) : null}
      <NewsletterPageStack
        form={form}
        setField={setField}
        frMap={frMap}
        onSaveHero={() => onSave("hero", NEWSLETTER_HERO_KEYS)}
        onSaveInside={() => onSave("inside", NEWSLETTER_INSIDE_KEYS)}
        onSaveArchive={() => onSave("archive", NEWSLETTER_ARCHIVE_KEYS)}
        savingSection={savingSection}
        canSaveHero={!exists || isSectionDirty(NEWSLETTER_HERO_KEYS)}
        canSaveInside={!exists || isSectionDirty(NEWSLETTER_INSIDE_KEYS)}
        canSaveArchive={!exists || isSectionDirty(NEWSLETTER_ARCHIVE_KEYS)}
      />
    </div>
  );
}
